<style lang="scss" scoped>
svg {
  transform: translateY(0);
}

.skillcol {
  padding-top: 9px;
}

.sticky {
  position: sticky;
  top: 10px;
  z-index: 99;

  &.form {
    max-height: 100vh;
    padding-right: 10px;
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 20px;
  }
}

.filter {
  z-index: 99;
  background-color: $c-off-white;
  position: relative;

  padding-bottom: 10px;
  padding-top: 10px;
  transform: translateY(-10px);
  input {
    padding: 10px 15px;
    filter: none;
    background: #fff;
    display: block;
    width: 100%;
    border: 1px solid $c-dark-grey;
    letter-spacing: 1px;

    &:focus {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
      outline: none;
    }
  }

  .icon {
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.units {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  .unit {
    width: 23%;
  }
}

h3 {
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 5px;
}

.skillitem {
  transition: 0.2s all;
  padding: 5px;
  padding-right: 20px;
  border: 1px solid $c-dark-grey;
  margin-bottom: 2px;
  cursor: pointer;
  position: relative;

  svg {
    position: absolute;
    right: 3px;
    top: 50%;
    transform: translateY(-50%);
  }

  &:hover {
    background-color: $c-medium-blue;
    color: $c-light-grey;

    svg {
      fill: $c-light-grey !important;
    }
  }

  &.active {
    background-color: $c-dark-blue;
    border-color: $c-dark-blue;
    color: $c-light-grey;
  }
}

.modalbutton {
  width: 100%;
}
</style>

<template>
  <div class="row">
    <div class="col-12 mb-1">
      <button @click="addSkill">{{ $t('management.skills.new') }}</button>
    </div>
  </div>

  <div class="row">
    <div class="col-3 skillcol">
      <div class="sticky">
        <div class="filter">
          <input placeholder="Filter" v-model="filter" />
          <div class="icon" @click="filter = ''" v-if="filter">
            <Icon :path="mdiClose" :width="20" :height="20" />
          </div>
        </div>
      </div>
      <div
        :key="skill.skill.id"
        v-for="skill of filteredskills"
        @click="selectSkill(skill.skill.id)"
        class="skillitem"
        :class="{ active: skill.skill.id == selected?.skill?.id }"
      >
        {{ skill.skill.name }}
        <!-- <Icon :path="mdiMagnify" :width="20" :height="20" /> -->
      </div>
    </div>
    <div class="col-9" v-if="selected">
      <div class="sticky form">
        <LabeledInput :label="$t('management.skills.name')" v-model="selected.skill.name" @focus="onFocus" />
        <LabeledSelect :label="$t('management.skills.type')" :options="groupoptions" v-model="selected.skill.group" />
        <LabeledInput :label="$t('management.skills.desc')" v-model="selected.skill.description" />

        <p class="mt-3">{{ $t('management.skills.addto') }}</p>
        <div class="units">
          <div class="unit" :key="unit.id" v-for="unit of selected.units"><Checkbox :label="unit.name" v-model="unit.selected" /></div>
        </div>

        <div class="row mt-3" v-if="selectedcnt > 0">
          <div class="col-6">
            <h3><Icon :path="mdiStar" :width="30" :height="30" /> {{ $t('legend.strategic') }}</h3>
            <TypeSelect :units="selected.units" v-model="selected.skill.strategic" :key="selected.skill.id" />
            <!-- <TypeSelect :units="selected.units" v-model="selected.skill.strategic" /> -->
          </div>
          <div class="col-6">
            <h3><Icon :path="mdiDiamond" :width="30" :height="30" /> {{ $t('legend.future') }}</h3>
            <TypeSelect :units="selected.units" v-model="selected.skill.future" :key="selected.skill.id" />
            <!-- <input type="text" v-model="selected.skill.future" /> -->
            <!-- <Checkbox :label="unit.name" v-model="selected.skill.future.includes(unit.id)" v-for="unit of selected.units" /> -->
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <h3><Icon :path="mdiCrown" :width="30" :height="30" /> {{ $t('legend.leadership') }}</h3>
            <Checkbox v-model="selected.skill.leadership" label="Dieser Skill ist ein Leadership Skill" />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <button @click="updateSkill">{{ $t('management.save') }}</button>
          </div>
          <div class="col-6">
            <ModalButton class="modalbutton" :link="`delete_skill_${selected.skill.id}`">
              <button>{{ $t('management.skills.delete') }}</button>
            </ModalButton>
            <Modal :link="`delete_skill_${selected.skill.id}`" :title="$t('management.deleteunit_title', { unit: selected.skill.name })">
              <p>{{ $t('management.skills.units') }}</p>
              <p>{{ $t('management.skills.grades') }}</p>
              <p>
                <button @click="removeSkill(selected?.skill.id)">{{ $t('management.deleteconfirm') }}</button>
              </p>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { mdiArrowRight, mdiMagnify, mdiDiamond, mdiStar, mdiCrown, mdiClose } from '@mdi/js';

import Modal from '../../../components/util/Modal.vue';
import ModalButton from '../../../components/util/ModalButton.vue';
import Checkbox from '../../../components/util/Checkbox.vue';
import TypeSelect from '../../../components/util/TypeSelect.vue';

interface Skill {
  id: number;
  name: string;
  group: string;
  description: string;
  strategic: Array<number>;
  future: Array<number>;
  leadership: boolean;
}

interface APIResult {
  skill: Skill;
  units: Array<{ id: number; name: string; selected: boolean }>;
}

export default defineComponent({
  components: {
    Modal,
    ModalButton,
    Checkbox,
    TypeSelect,
  },
  setup() {
    const store = useStore();

    const skills = ref<Array<APIResult>>();
    const units = ref<Array<{ id: number; name: string; selected: boolean }>>([]);
    const init = () => {
      store.dispatch('API', { url: `admin/skills` }).then((res: any) => {
        skills.value = res.data.message.sort((a: APIResult, b: APIResult) => {
          if (a.skill.id > b.skill.id) return 1;
          if (a.skill.id < b.skill.id) return -1;
          return 0;
        }) as Array<APIResult>;

        //skills.value = res.data.message.sort((a,b)=> store.getters.getSort(a,b)) as Array<APIResult>;

        //selected.value = JSON.parse(JSON.stringify(skills.value[id]));
      });
      store.dispatch('fetchUnits').then((res: any) => {
        units.value = JSON.parse(JSON.stringify(res));
      });
    };

    const filter = ref('');

    const filteredskills = computed(() => {
      return skills.value?.filter((item) => item.skill.name.toLocaleLowerCase().includes(filter.value.toLocaleLowerCase()));
    });

    const selected = ref<APIResult | undefined>();
    const selectSkill = (id: number) => {
      if (skills.value) {
        selected.value = skills.value.find((item) => item.skill.id == id);

        selected.value?.units.sort((a: any, b: any) => {
          if (a.id > b.id) return 1;
          if (b.id > a.id) return -1;
          return 0;
        });
      }
      return;
    };

    const selectedcnt = computed(() => {
      if (selected.value == undefined) return 0;
      return selected.value.units.filter((unit) => unit.selected).length;
    });

    onMounted(() => {
      init();
    });

    const groupoptions = [
      { label: 'Persönliche Skills', value: 'personal' },
      { label: 'Soziale Skills', value: 'social' },
      { label: 'Fachliche Skills', value: 'working' },
    ];

    const addSkill = () => {
      if (skills.value) {
        const id = -skills.value.length;
        skills.value.unshift({
          skill: {
            id,
            name: 'Neuer Skill',
            group: 'personal',
            description: '',
            strategic: [],
            future: [],
            leadership: false,
          },
          units: units.value.map((item: any) => {
            item.selected = false;
            return item;
          }),
        });

        selectSkill(id);
      }
    };

    const updateSkill = () => {
      if (selected.value) {
        if (selected.value.skill.id < 0) {
          store.dispatch('API', { url: `admin/skills`, method: 'post', data: { ...selected.value } }).then(() => {
            init();
            store.dispatch('addNotification', { message: 'Skill gespeichert' });
            store.dispatch('fetchSkills', { force: true });
          });
        } else {
          store.dispatch('API', { url: `admin/skills/${selected.value.skill.id}`, method: 'patch', data: { ...selected.value } }).then(() => {
            init();
            store.dispatch('addNotification', { message: 'Skill gespeichert' });
            store.dispatch('fetcshSkills', { force: true });
          });
        }
      }
    };

    const removeSkill = (id: number | undefined) => {
      if (id == -1) {
        // TODO: What to do....
      } else {
        store.dispatch('setModal', { link: `delete_skill_${id}`, value: false });
        store.dispatch('API', { url: `admin/skills/${id}`, method: 'delete' }).then(() => {
          selected.value = undefined;
          init();
        });
      }
    };

    const onFocus = () => {
      if (selected.value?.skill.name == 'Neuer Skill') {
        selected.value.skill.name = '';
      }
    };

    return {
      skills,
      filteredskills,
      selected,
      selectSkill,
      groupoptions,
      updateSkill,
      addSkill,
      units,
      removeSkill,
      mdiArrowRight,
      mdiMagnify,
      mdiDiamond,
      mdiStar,
      mdiCrown,
      mdiClose,
      onFocus,
      selectedcnt,
      filter,
    };
  },
});
</script>
